
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Capture the essence of Goa with a professional photographer. Whether it’s a special event or stunning portraits, create lasting memories with high-quality photography.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover professional photography services in Goa. From beautiful landscapes to vibrant local scenes, capture every moment in stunning detail.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Book a professional photographer in Goa to capture stunning moments. From events to portraits, enjoy high-quality photography at beautiful locations.',
},


        {
          hid: 'keywords',
          name: 'keywords',
          content: 'professional photographer, professional photographer in goa, vsnapu goa, vsnapu photography, vsnapu photography candolim goa, the professional photographer in goa, drone photography in goa, pre-wedding photography in goa, couple photography in goa',
        },
       
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Locations",
      text: "Capture breathtaking views and hidden gems with the best photography spots in Goa!",
    },
    {
      title: "Perfect for Everyone",
      text: "Whether you're a pro or just starting, there's something for every photography lover!",
    },
    {
      title: "Local Experts",
      text: "Our experienced photographers guide you to the best locations and give helpful tips.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect photography experience easily through the Goa App at great rates!",
    },
  ],

     
      title: 'Professional Photographers in Goa - Best Photography in Goa ',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/professional-photographer-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/professional-photographer-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/professional-photographer-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Professional Photographer in Goa - Book @ ₹4999 Flat 17% Off",
  "description": "Enjoy the best professional photography experience in Goa with stunning landscapes, vibrant culture, and unique moments captured for an unforgettable visual journey..",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "4999",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/professional-photographer-goa",
        "url": "https://www.goa.app/professional-photographer-goa",
        "name": "Professional Photographer in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.942Z5.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=lBvEr3dcg4LOcRTxY0OXg0pIziS6oBM%2Fanr%2BnhXask6E3lKjISwGt8MUEjjhk3%2BHr0ditAvWF1aVQX%2F9oJTjTISZzk3I97fuhIujhoiG%2F2bYAna4Al3nd0IsEFb6Gfv1p3v471stlc0mpj7mSPrqP2IHZnQQzU78BnNCCklX8kKsUsPjP%2Be8lRmHUpEvv1CuUD2HTubFwd60e87O%2Bcc3aXoaI03%2Bh5Sjo9VI7LcJ50J7x0a3Kq4y4459VsvXZHUVVD5oQstwyMNcr19%2BmtESKASZyx1vgPFoAI07ASgWZ69CwnXuBnx5iXxxk11%2FVkb8xSGOAkVOCaDkDxChOxYu3A%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Professional Photography in Goa captures the stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for photography enthusiasts looking to frame beautiful sunsets, historic sites, and lush greenery.",
        "breadcrumb": {
            "@id": "https://www.goa.app/professional-photographer-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/professional-photographer-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
    "@type": "Question",
    "name": "What are the benefits of hiring a professional photographer in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hiring a professional photographer in Goa ensures high-quality images that capture the essence of your special moments, utilizing their expertise in lighting and composition."
    }
  },
  {
    "@type": "Question",
    "name": "What types of photography services are offered by professionals in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Professional photographers in Goa offer a range of services, including wedding photography, family portraits, pre-wedding shoots, and event photography."
    }
  },
  {
    "@type": "Question",
    "name": "How much does it cost to hire a professional photographer in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The cost of hiring a professional photographer in Goa typically starts from ₹5,000 and can vary based on the type of shoot and package selected."
    }
  },
  {
    "@type": "Question",
    "name": "Can I customize my photography package?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many professional photographers in Goa offer customizable packages to fit your specific needs and preferences."
    }
  },
  {
    "@type": "Question",
    "name": "What is the best time for a photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The best time for a photoshoot in Goa is during the golden hours, just after sunrise or before sunset, for the best natural lighting."
    }
  },
  {
    "@type": "Question",
    "name": "Are there any location restrictions for professional photoshoots?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Some locations in Goa may have restrictions for professional photography, particularly private properties or during specific events, so it's best to check beforehand."
    }
  },
  {
    "@type": "Question",
    "name": "Do professional photography packages include editing services?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, most professional photography packages in Goa include basic editing services, with options for additional retouching available for an extra fee."
    }
  },
  {
    "@type": "Question",
    "name": "Can I choose specific locations for my photoshoot?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely! Professional photographers often work with you to choose locations that best reflect your style and vision."
    }
  },
  {
    "@type": "Question",
    "name": "What should I wear for a professional photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Opt for comfortable, vibrant outfits that complement the scenic backgrounds. Light fabrics and bright colors are recommended for Goa's sunny climate."
    }
  },
  {
    "@type": "Question",
    "name": "How do I book a professional photographer in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can book a professional photographer in Goa through various platforms, including dedicated photography websites and apps, to find reputable professionals and view package details."
    }
  }
        ]
      }
    ]
  };
},


};



  